import { render, staticRenderFns } from "./resourceManage.vue?vue&type=template&id=eda9e422&scoped=true"
import script from "./resourceManage.vue?vue&type=script&lang=js"
export * from "./resourceManage.vue?vue&type=script&lang=js"
import style0 from "./resourceManage.vue?vue&type=style&index=0&id=eda9e422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda9e422",
  null
  
)

export default component.exports